type Input = {
    stepIdx: number;
    totalStep: number;
};
export function isSecondLastPage({ stepIdx, totalStep }: Input) {
    return stepIdx === totalStep - 2;
}
